class BabyBatEngraving extends HTMLElement {
  constructor() {
    super();

    this.popup = this.querySelector('.engraving-popup');
    this.customizeBtn = this.querySelector('.js-add-engraving');
    this.closePopupBtn = this.querySelector('.js-engraving-popup-close');
    this.submitBtn = this.querySelector('.engraving-popup-submit');

    this.pinkBat = this.querySelector('.engraving-popup-image-pink');
    this.blueBat = this.querySelector('.engraving-popup-image-blue');

    // bind events
    this.customizeBtn.addEventListener('click', () => this.open());
    this.closePopupBtn.addEventListener('click', () => this.close());
    const self = this;
    this.submitBtn.addEventListener('click', (event) => {
      event.preventDefault();
      self.submit();
    });

    this.babyName = this.querySelector('#engravind-baby-name');
    this.babyName.addEventListener("input", (event) => {
      document.querySelector('.engraving-popup .engraving-image-name').innerHTML = event.target.value;
    });

    this.weight = this.querySelector('#engravind-weight');
    this.weight.addEventListener("input", (event) => {
      document.querySelector('.engraving-popup .engraving-image-weight').innerHTML = event.target.value;
    });

    this.height = this.querySelector('#engravind-height');
    this.height.addEventListener("input", (event) => {
      document.querySelector('.engraving-popup .engraving-image-height').innerHTML = event.target.value;
    });
  }

  open() {
    const selectedColor = document.querySelector('.bn--selector__color-swatches input');
    if (selectedColor.checked) {
      // boy names
      document.querySelector('.engraving-popup .engraving-image-time').innerHTML = '9:10pm';
      document.querySelector('.engraving-popup .engraving-image-date').innerHTML = 'May 30, 2024';
      document.querySelector('.engraving-popup .engraving-image-name').innerHTML = 'Elijah Thomas Walker';
      this.babyName.value = 'Elijah Thomas Walker';
      document.querySelector('.engraving-popup .engraving-image-weight').innerHTML = '8lbs 2oz';
      this.weight.value = '8lbs 2oz';
      document.querySelector('.engraving-popup .engraving-image-height').innerHTML = '21"';
      this.height.value = '21"';

      this.pinkBat.classList.add('hide');
      this.blueBat.classList.remove('hide');
      
    } else {
      // girl names
      document.querySelector('.engraving-popup .engraving-image-time').innerHTML = '6:45pm';
      document.querySelector('.engraving-popup .engraving-image-date').innerHTML = 'September 4, 2024';
      document.querySelector('.engraving-popup .engraving-image-name').innerHTML = 'Isabella Marie Davis';
      this.babyName.value = 'Isabella Marie Davis';
      document.querySelector('.engraving-popup .engraving-image-weight').innerHTML = '8lbs 11oz';
      this.weight.value = '8lbs 11oz';
      document.querySelector('.engraving-popup .engraving-image-height').innerHTML = '21"';
      this.height.value = '21"';

      this.pinkBat.classList.remove('hide');
      this.blueBat.classList.add('hide');
    }

    const selectedDate = document.querySelector('.engraving-popup #engravind-date-time');
    const dateParts = selectedDate.value.split(',');

    document.querySelector('.engraving-popup .engraving-image-time').innerHTML = dateParts[2];
    document.querySelector('.engraving-popup .engraving-image-date').innerHTML = dateParts[0] + ',' + dateParts[1];

    this.popup.classList.add('open');
    document.querySelector('body').classList.add('popup-open');
  }

  close() {
    this.popup.classList.remove('open');
    document.querySelector('body').classList.remove('popup-open');
  }

  submit() {
    const toCartButton = this.submitBtn;
    toCartButton.setAttribute('disabled', true);
    let formData = {
      'items': [
        {
          'id': this.submitBtn.getAttribute('data-engraving-variant'),
          'quantity': 1,
          "properties" : {
            "Baby name": this.querySelector('#engravind-baby-name').value,
            "Date of birthday": this.querySelector('#engravind-date-time').value,
            "Weight (pound)": this.querySelector('#engravind-weight').value,
            "Height (inches)": this.querySelector('#engravind-height').value,
          }
        },
        {
          'id': this.submitBtn.getAttribute('data-base-product'),
          'quantity': 1,
          "properties" : {
            "_engraving": this.submitBtn.getAttribute('data-engraving-variant')
          }
        }
      ]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
        toCartButton.removeAttribute('disabled');
        this.close();
        return response.json();
    })
    .catch((error) => {
        console.error('Error:', error);
    });
  }
}

customElements.define('baby-bat-engraving', BabyBatEngraving);
